<script setup>

    import { useSlots } from 'vue'
    const slots = useSlots()

    const props = defineProps({
        value: {
            type: String,
        },
        palette: {
            type: String,
            default: 'gray'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        position: {
            type: String,
            default: 'left' // left, right
        }
    })

</script>

<template>
    <label
        :class="[
            'block font-medium text-sm group',
            {
                // 'cursor-pointer': slots.default,
                'text-stone-500': props.palette == 'gray',
                'text-lifeworx-blue-800': props.palette == 'blue',
                'text-lifeworx-purple-500': props.palette == 'purple',
                'font-semibold': props.palette == 'blue' || props.palette == 'purple',
                'opacity-50': props.disabled
            }
        ]"
    >
        <span
            v-if="props.value && props.position == 'left'"
            class="block mb-1"
        >
            {{ props.value }}
        </span>
        <slot />
        <span
            v-if="props.value && props.position == 'right'"
            class="block mb-1"
        >
            {{ props.value }}
        </span>
    </label>
</template>
